module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "introduction-section"
  }, [_c('div', {
    staticClass: "introduction-section__body container"
  }, [_c('h1', {
    staticClass: "introduction-section__body__heading"
  }, [_vm._v("\n      Gateway to Africa\n    ")]), _vm._v(" "), _c('share', {
    staticClass: "text-left"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1086cdcf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroductionSection.vue
// module id = 605
// module chunks = 1